
import brands from '@/brands/brands.json';


export function brandDetector() {

	
	var domain = location.host;

	var brandsIndex = {
		'tutores-uax.dev.doubledot.es' : 'uax' ,
		'tutores.empleo.uax.es' : 'uax' ,
		'tutores.dev.doubledot.es' : 'dotia', 
		'tutores-comillas.dev.doubledot.es' : 'comillas',
		'tutores-uc3m.dev.doubledot.es' : 'uc3m',
		'tutores-uva.dev.doubledot.es' : 'uva',
		'tutor.uvaempleo.com' : 'uva',
		'tutores-uib.dev.doubledot.es' : 'uib',
		'localhost:8080' : 'uax',
		'localhost:8081' : 'uib'
	};

	var selected = brandsIndex[domain];

	//SETEO DE LOS FAVICONS

	if(!!selected){

		if(!!brands[selected].hasFavicon){

			var url = '/static/img/brands/'+selected+'/favicon/';

			document.head.querySelector("[name=big-favicon]").href = url+'apple-touch-icon.png';
			document.head.querySelector("[name=medium-favicon]").href = url+'favicon-32x32.png';
			document.head.querySelector("[name=small-favicon]").href = url+'favicon-16x16.png';
			document.head.querySelector("[name=favicon]").href = url+'favicon.ico';
			document.head.querySelector("[name=msapplication-config]").href = url+'browserconfig.xml';
			document.head.querySelector("[name=webmanifest]").href = url+'site.webmanifest';

		}

		return brands[selected];
		

	}else{
		return brands['dotia'];
	}

}


// WEBPACK FOOTER //
// ./src/brands/index.js